var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "registration-content" },
    [
      _c(_vm.currentComponent, {
        tag: "component",
        attrs: { "loading-state": _vm.loadingState },
        on: {
          submit: _vm.handleAccountCreate,
          verify: _vm.handleVerifyAccount,
          "resend-code": _vm.handleResendCode,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }